import { Container } from 'inversify'
import { ConfigProvider } from './ConfigProvider'
import { StaticConfigProvider } from './StaticConfigProvider'

export const SERVICES = {
  ConfigProvider: Symbol.for('ConfigProvider'),
  AuthService: Symbol.for('AuthService'),
  HttpRequestContext: Symbol.for('HttpRequestContext'),
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function registerBinding(container: Container) {
  container.bind<ConfigProvider>(SERVICES.ConfigProvider).to(StaticConfigProvider).inTransientScope()
}

//  DO NOT DELETE - used by DW
